import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Grid2X2Plus } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import { useGrid } from '@/components/Grid';
import { getInfo } from '@/components/Grid/components/Table/formatters';

export default function EditBlockEntity({ info }) {
  const { row } = getInfo(info)
  const { definitions: { basePath, entityNameModule, entityNamePlural } } = useGrid()

  const path = useMemo(() => {
    if (basePath) return basePath;
    return `/${entityNameModule}/${entityNamePlural.toLowerCase()}`
  }, [basePath, entityNameModule, entityNamePlural])

  return <>
    <DefaultTooltip content='Edit Block'>
      <Link to={`${path}/${row.id}/builder-blocks`}>
        <Grid2X2Plus size={16} />
      </Link>
    </DefaultTooltip>
  </>
}
